import { c as _c } from "react/compiler-runtime";
import { Children } from 'react';
import cx from 'classnames';
import { MenuList, ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Button from '@classify/react-core-components/Button';
import Loader from '@classify/react-core-components/Loader';
import Typography from '@classify/react-core-components/Typography';
const useStyles = makeStyles(({
  palette
}) => ({
  root: {
    maxHeight: 160,
    overflow: 'auto'
  },
  noResults: {
    paddingTop: 0,
    paddingBottom: 0
  },
  noResultsQuery: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: palette.text.secondary
  }
}), {
  classNamePrefix: 'MenuPaginatedList'
});
const MenuPaginatedList = t0 => {
  const $ = _c(27);
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      children: t1,
      isLoading: t2,
      translations: t3,
      createUrl: t4,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  const children = t1 === undefined ? null : t1;
  const isLoading = t2 === undefined ? false : t2;
  let t5;
  if ($[6] !== t3) {
    t5 = t3 === undefined ? {
      noResults: "\"XXX\" not found",
      loading: "Loading",
      createButton: "Create",
      noResultGeneric: "No results"
    } : t3;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const translations = t5;
  const createUrl = t4 === undefined ? "" : t4;
  const classes = useStyles();
  let t6;
  if ($[8] !== children) {
    t6 = Children.toArray(children);
    $[8] = children;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const hasChildren = t6.length > 0;
  let t7;
  if ($[10] !== classes.noResultsQuery || $[11] !== createUrl || $[12] !== translations.createButton || $[13] !== translations.noResultGeneric || $[14] !== translations.noResults) {
    t7 = createUrl ? <><Typography className={classes.noResultsQuery} display="inline" variant="body">{translations.noResults}</Typography><Button sx={{
        flexShrink: 0
      }} variant="tertiary" component="a" href={createUrl} target="_blank">{translations.createButton}</Button></> : <Typography className={classes.noResultsQuery} display="inline" variant="body">{translations.noResultGeneric}</Typography>;
    $[10] = classes.noResultsQuery;
    $[11] = createUrl;
    $[12] = translations.createButton;
    $[13] = translations.noResultGeneric;
    $[14] = translations.noResults;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const noResult = t7;
  let t8;
  if ($[16] !== classes.noResults || $[17] !== hasChildren || $[18] !== isLoading || $[19] !== noResult || $[20] !== translations.loading) {
    t8 = !hasChildren && <ListItem tabIndex={-1} className={cx({
      [classes.noResults]: !isLoading
    })}>{isLoading ? <><Loader size={24} thickness="small" aria-label="" /><Typography color="text.secondary" display="inline" variant="bodySmall">{translations.loading}</Typography></> : noResult}</ListItem>;
    $[16] = classes.noResults;
    $[17] = hasChildren;
    $[18] = isLoading;
    $[19] = noResult;
    $[20] = translations.loading;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== children || $[23] !== classes.root || $[24] !== otherProps || $[25] !== t8) {
    t9 = <><MenuList className={classes.root} {...otherProps}>{children}{t8}</MenuList></>;
    $[22] = children;
    $[23] = classes.root;
    $[24] = otherProps;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export default MenuPaginatedList;